
import { Component,  OnInit } from '@angular/core';
import { CommonModule, NgForOf, NgIf, NgClass } from '@angular/common';

import { Router } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import {
  MatAccordion,
  MatExpansionModule,
  MatExpansionPanel,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { TableControlsComponent } from '../clients/table-controls/table-controls.component';

//

import {ChangeDetectionStrategy,  inject, model, signal, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';

import {MatInputModule} from '@angular/material/input';
import {  FormBuilder, ReactiveFormsModule, Validators, FormGroup ,FormControl } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

import {MatTabsModule} from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';

import { MatTableModule } from '@angular/material/table';




import { LbnContainerComponent, CheckboxesComponent,LbnInputFieldComponent ,TitleComponent ,LbnAccordianComponent,InputDropdownComponent ,DataPickerComponent ,
  FormActionsButtonsComponent,LbnActionButtonComponent,RadioButtonsComponent} from '../../shared/components';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';

import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HomeService, ClientData, Branch, Client, ClientsListResponse, SuspendClientRequest, ReactivateClientRequest, UpdateClientRequest } from '../../services/home.service';

export interface DialogData {
  animal: string;
  name: string;
  branches?: Branch[];
  subBranches?: Branch[];
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule ,TableControlsComponent,NgIf,NgForOf,NgClass,MatIconModule,MatExpansionModule,MatAccordion,MatExpansionPanel,MatExpansionPanelTitle],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  /**************  DATA ARRAYS  **************/
  allCompanies: CompanyNotification[] = [];
  newCompanies: CompanyNotification[] = [];
  activeCompanies: CompanyNotification[] = [];
  oldCompanies: CompanyNotification[] = [];
  branches: Branch[] = [];
  conditionOptions: Branch[] = [];

  /**************  UI BEHAVIOUR  **************/
  showAllNew = false;
  showAllActive = false;
  showAllOld = false;
  itemsToShow = 5;
  readonly searchTerm = signal('');
  isLoadingClients = true;
  isDialogOpening = false;

  /**************  PAGINATION  **************/
  currentPage = 1;
  pageSize = 5;
  totalPages = 1;
  totalItems = 0;
  paginatedCompanies: CompanyNotification[] = [];
  Math = Math; // Expose Math to template

   readonly animal = signal('');
  readonly name = model('');
  readonly dialog = inject(MatDialog);


  openDialog(): void {
    // Prevent multiple simultaneous dialog openings
    if (this.isDialogOpening) {
      console.log('⚠️ Dialog is already opening, ignoring duplicate click');
      return;
    }

    this.isDialogOpening = true;
    console.log('🔍 Fetching branches and sub-branches before opening Add Client dialog');

    // Fetch branches and sub-branches in parallel before opening the modal
    forkJoin({
      branches: this.homeService.getBranches(),
      subBranches: this.homeService.getSubBranches()
    }).subscribe({
      next: ({ branches, subBranches }) => {
        console.log('✅ Branches and sub-branches loaded, opening Add Client dialog');

        // Open dialog with pre-fetched data
        const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
          width: '800px',
          disableClose: true, // Prevent closing when clicking outside
          data: {
            name: this.name(),
            animal: this.animal(),
            branches: branches.branches,
            subBranches: subBranches.branches
          },
        });

        // Reset the flag once dialog is opened
        this.isDialogOpening = false;

        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          // If dialog returns a company object, reload the clients list from API
          if (result && typeof result === 'object' && (result.ClientName || result.clientName)) {
            console.log('✅ New client added, reloading clients list');
            // Reload the entire list from API to get fresh data
            this.loadClientsFromAPI();
            this.cd.markForCheck();
            return;
          }

          // Fallback behavior for previous result usage
          if (result !== undefined) {
            this.animal.set(result);
          }
        });
      },
      error: (error) => {
        // Reset the flag on error as well
        this.isDialogOpening = false;
        console.error('❌ Failed to load branches/sub-branches:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed to load required data',
          text: 'Could not load branches and conditions. Please try again.',
          confirmButtonColor: '#3FB498',
        });
      }
    });
  }

  openLicenseExpiryDialog(clientId: string): void {
    if (!clientId) {
      console.error('❌ No client ID provided');
      return;
    }

    console.log('🔍 Opening license expiry dialog for client ID:', clientId);
    console.log('📋 Current client list IDs:', this.newCompanies.map(c => ({ id: c.id, clientId: c.clientId, name: c.ClientName })));

    const dialogRef = this.dialog.open(LicenseExpiryDialog, {
      width: '600px',
      maxHeight: '90vh',
      disableClose: true, // Prevent closing when clicking outside
      data: { clientId },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('License expiry dialog closed', result);
      if (result) {
        // Handle the license expiry data (e.g., update the company status)
        console.log('License expiry data:', result);
        // Reload clients to reflect any status changes
        this.loadClientsFromAPI();
        try { this.cd.markForCheck(); } catch {}
      }
    });
  }

  openReactivateDialog(clientId: string): void {
    if (!clientId) {
      console.error('❌ No client ID provided');
      return;
    }

    console.log('🔍 Fetching client data before opening reactivate dialog for client ID:', clientId);

    // Fetch client data first to get the license expiry date
    this.homeService.getClientById(clientId).subscribe({
      next: (client) => {
        console.log('✅ Client data loaded for reactivate dialog:', client);

        const dialogRef = this.dialog.open(ReactivateClientDialog, {
          width: '600px',
          maxHeight: '90vh',
          disableClose: true, // Prevent closing when clicking outside
          data: {
            clientId,
            clientData: client // Pass client data including expiry date
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Reactivate dialog closed', result);
          if (result) {
            // Handle the reactivation data
            console.log('Reactivation data:', result);
            // Reload clients to reflect any status changes
            this.loadClientsFromAPI();
            try { this.cd.markForCheck(); } catch {}
          }
        });
      },
      error: (error) => {
        console.error('❌ Failed to load client data:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed to load client data',
          text: 'Could not load client information. Please try again.',
          confirmButtonColor: '#3FB498',
        });
      }
    });
  }

  openUpdateClientDialog(clientId: string): void {
    if (!clientId) {
      console.error('❌ No client ID provided');
      return;
    }

    console.log('🔍 Fetching client data before opening dialog for client ID:', clientId);

    // Fetch client data first before opening the modal
    this.homeService.getClientById(clientId).subscribe({
      next: (client) => {
        console.log('✅ Client data loaded, opening dialog:', client);

        // Open dialog with pre-fetched client data
        const dialogRef = this.dialog.open(UpdateClientDialog, {
          width: '900px',
          maxHeight: '100vh',
          disableClose: true, // Prevent closing when clicking outside
          data: {
            clientId,
            clientData: client // Pass pre-fetched data
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Update client dialog closed', result);
          if (result) {
            // Handle the update data
            console.log('Update data:', result);
            // Reload clients to reflect any changes
            this.loadClientsFromAPI();
            try { this.cd.markForCheck(); } catch {}
          }
        });
      },
      error: (error) => {
        console.error('❌ Failed to load client data:', error);

        // Handle 404 error specifically (client not found)
        if (error.status === 404) {
          Swal.fire({
            icon: 'warning',
            title: 'Client Not Found',
            html: `
              <p>The client you're trying to access could not be found.</p>
              <p>This usually means the client was deleted or the data is out of sync.</p>
              <p><strong>The page will refresh to show current data.</strong></p>
            `,
            confirmButtonText: 'Refresh Now',
            confirmButtonColor: '#3FB498',
          }).then(() => {
            this.loadClientsFromAPI();
            try { this.cd.markForCheck(); } catch {}
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed to load client data',
            text: error.error?.message || 'Please try again later',
            confirmButtonColor: '#3FB498',
          });
        }
      }
    });
  }
  constructor(
    private router: Router,
    private cd: ChangeDetectorRef,
    private homeService: HomeService
  ) {}

  ngOnInit(): void {
    this.loadBranches();
    this.loadSubBranches();
    this.loadClientsFromAPI();
  }

  /**
   * Load clients from API for the current page.
   * Pagination is server-driven: totalItems / totalPages come from the response.
   */
  private loadClientsFromAPI(): void {
    this.isLoadingClients = true;
    this.cd.markForCheck();

    this.homeService.getClients(this.currentPage, this.pageSize, this.searchTerm() || undefined)
      .pipe(finalize(() => {
        this.isLoadingClients = false;
        this.cd.markForCheck();
      }))
      .subscribe({
        next: (response: ClientsListResponse) => {
          console.log('📦 Loading clients from API:', response);
          try {
            const mapped = (response.data ?? []).map((client: Client) => ({
              id: client.id,
              clientId: client.id,
              ClientName: client.clientName ?? '',
              companyRegNo: client.companyRegNo || 'N/A',
              CMSFinNumber: client.cmsFinNumber ?? '',
              Registration: this.homeService.formatDateToDDMMYYYY(client.registrationDate),
              EmployeeHeadcountLimit: client.employeeHeadCountLimit != null ? String(client.employeeHeadCountLimit) : '',
              Branch: this.getBranchName(client.branch ?? ''),
              status: client.status || 'Pending',
              licenceExpiryDate: client['licenceExpiryDate'] || client['licenseExpiryDate']
            }));

            this.allCompanies = mapped;
            this.newCompanies = mapped;
            this.paginatedCompanies = mapped;
            this.totalItems = response.totalItems ?? mapped.length;
            this.totalPages = response.totalPages ?? Math.max(1, Math.ceil(this.totalItems / this.pageSize));
            this.currentPage = response.page ?? this.currentPage;
          } catch (err) {
            console.error('❌ Failed to map clients response:', err);
            this.allCompanies = [];
            this.newCompanies = [];
            this.paginatedCompanies = [];
          }
        },
        error: (error) => {
          console.error('❌ Failed to load clients:', error);
          this.allCompanies = [];
          this.newCompanies = [];
          this.paginatedCompanies = [];
          this.totalItems = 0;
          this.totalPages = 1;
        }
      });
  }

  /**
   * Load branches from API
   */
  private loadBranches(): void {
    this.homeService.getBranches().subscribe({
      next: (response) => {
        this.branches = response.branches;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error loading branches:', error);
        this.branches = [];
        this.cd.markForCheck();
      }
    });
  }

  /**
   * Load sub-branches (conditions) from API
   */
  private loadSubBranches(): void {
    this.homeService.getSubBranches().subscribe({
      next: (response) => {
        this.conditionOptions = response.branches;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error loading sub-branches:', error);
        this.conditionOptions = [];
        this.cd.markForCheck();
      }
    });
  }

  /**
   * Convert branch code to branch name for display
   */
  private getBranchName(branchCode: string): string {
    // First check if it's a sub-branch
    const subBranch = this.conditionOptions.find(b => b.code === branchCode);
    if (subBranch) {
      return subBranch.name;
    }

    // Otherwise check main branches
    const mainBranch = this.branches.find(b => b.code === branchCode);
    if (mainBranch) {
      return mainBranch.name;
    }

    // Fallback to the code if not found
    return branchCode;
  }

  /**************  INTERACTIONS  **************/
  toggleShowAll(type: 'new' | 'active' | 'old'): void {
    if (type === 'new') this.showAllNew = !this.showAllNew;
    if (type === 'active') this.showAllActive = !this.showAllActive;
    if (type === 'old') this.showAllOld = !this.showAllOld;
  }

  /**
   * Get status color based on license expiry date
   * - Green (#3fb498): Active with >10 days until expiry or no expiry date
   * - Yellow (#f9cf16): Active/Suspended with <=10 days until expiry
   * - Red (#eb5757): Expired (expiry date is past today) or Suspended/Non-active without expiry check
   * - Grey: Pending status
   */
  

  getStatusClass(status: string): string {
    switch (status) {
      case 'Pending':
        return 'status-requested';
      case 'Active':
        return 'status-approved';
      case 'Non-active':
      case 'Suspended':
        return 'status-declined';
      default:
        return '';
    }
  }

  /**
   * Check if expiry warning should be shown
   * Shows warning only if expiring within 10 days or already expired
   * Applies to both Active and Suspended statuses
   */
  shouldShowExpiryWarnings(company: CompanyNotification): boolean {
    if (!company.licenceExpiryDate) {
      return false;
    }

    // Only show for Active or Suspended status
    if (company.status !== 'Active' && company.status !== 'Suspended') {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiryDate = new Date(company.licenceExpiryDate);
    expiryDate.setHours(0, 0, 0, 0);

    const diffTime = expiryDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Show warning only if expiring within 10 days or already expired
    return diffDays <= 10;
  }

  /**
   * Get formatted expiry date string for display with appropriate prefix
   * Returns "Expired on DD-MM-YYYY" if past today
   * Returns "Expires on DD-MM-YYYY" if today or future
   */
  getFormattedExpiryDates(company: CompanyNotification): string {
    if (!company.licenceExpiryDate) {
      return '';
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiryDate = new Date(company.licenceExpiryDate);
    expiryDate.setHours(0, 0, 0, 0);

    const formattedDate = this.homeService.formatDateToDDMMYYYY(company.licenceExpiryDate);

    // If expiry date is before today, show "Expired on"
    if (expiryDate.getTime() < today.getTime()) {
      return `Expired on ${formattedDate}`;
    }

    // Otherwise show "Expires on"
    return `Expires on ${formattedDate}`;
  }


  // new code 
getStatusColor(company: CompanyNotification): string {
  // Handle Pending status
  if (company.status === 'Pending') {
    return '#878787'; // Grey for Pending
  }

  // For Active or Suspended status with expiry date, check the date
  if ((company.status === 'Active' || company.status === 'Suspended') && company.licenceExpiryDate) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiryDate = new Date(company.licenceExpiryDate);
    expiryDate.setHours(0, 0, 0, 0);

    // Calculate days until expiry
    const diffTime = expiryDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
      // Expired (past today's date)
      return '#eb5757'; // Red
    } else if (diffDays <= 10) {
      // Expiring within 10 days (including today)
      return '#f9cf16'; // Yellow
    } else {
      // More than 10 days until expiry
      if (company.status === 'Suspended') {
        return '#f9cf16'; // Yellow for Suspended with more than 10 days
      }
      return '#3fb498'; // Green for Active with more than 10 days
    }
  }

  // Default colors for statuses without expiry date check
  if (company.status === 'Suspended' || company.status === 'Non-active' || company.status ==='Failed') {
    return '#eb5757'; // Red for Suspended/Non-active without expiry date
  }

  // Default: Active without expiry date
  return '#3fb498'; // Green
}

getFormattedExpiryDate(company: CompanyNotification): string {
  if (!company.licenceExpiryDate) {
    return '';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const expiryDate = new Date(company.licenceExpiryDate);
  expiryDate.setHours(0, 0, 0, 0);

  // Calculate days until expiry
  const diffTime = expiryDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Format the date as DD-MM-YYYY to match your UI
  const day = expiryDate.getDate().toString().padStart(2, '0');
  const month = (expiryDate.getMonth() + 1).toString().padStart(2, '0');
  const year = expiryDate.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  if (diffDays < 0) {
    // Expired
    return `Expired on ${formattedDate}`;
  } else if (diffDays <= 10) {
    // Expiring within 10 days
    return `Expires on ${formattedDate}`;
  }

  return ''; // No message for more than 10 days
}

shouldShowExpiryWarning(company: CompanyNotification): boolean {
  if (!company.licenceExpiryDate) {
    return false;
  }

  if (company.status !== 'Active' && company.status !== 'Suspended') {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const expiryDate = new Date(company.licenceExpiryDate);
  expiryDate.setHours(0, 0, 0, 0);

  // Calculate days until expiry
  const diffTime = expiryDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Show warning if expired or expiring within 10 days
  return diffDays <= 10;
}
  onRowClick(company: CompanyNotification): void {
    console.log('Clicked company:', company);
  }


  goToBilling(company: any): void {
    // Navigate to client details page with client ID
    console.log('Navigating to Client Details for:', company);

    // Use clientId if available, fallback to id
    const clientId = company.clientId || company.id;

    if (clientId) {
      // Navigate to client-details route with clientId as query parameter
      this.router.navigate(['/client-details'], {
        queryParams: { clientId: clientId }
      });
    } else {
      console.error('❌ No client ID available for navigation');
    }
  }

  
  handleEvents(event: { value?: string; action: string }) {

    switch (event.action) {
      case 'search':
        this.searchCompanies(event.value || '');
        break;
      case 'clear':
        this.clearSearch();
        break;
      case 'new':
        this.openDialog();
        break;
      case 'filter':
        this.searchCompanies(event.value || '');
        break;
      case 'status':
       // this.filterByStatus(event.value);
    }
  }

  private searchCompanies(term: string): void {
    this.searchTerm.set(term ?? '');
    this.currentPage = 1;
    this.loadClientsFromAPI();
  }

  clearSearch(): void {
    if (!this.searchTerm()) return;
    this.searchTerm.set('');
    this.currentPage = 1;
    this.loadClientsFromAPI();
  }

  /**************  PAGINATION METHODS  **************/
  goToFirstPage(): void {
    if (this.currentPage === 1) return;
    this.currentPage = 1;
    this.loadClientsFromAPI();
  }

  goToPreviousPage(): void {
    if (this.currentPage <= 1) return;
    this.currentPage--;
    this.loadClientsFromAPI();
  }

  goToNextPage(): void {
    if (this.currentPage >= this.totalPages) return;
    this.currentPage++;
    this.loadClientsFromAPI();
  }

  goToLastPage(): void {
    if (this.currentPage === this.totalPages) return;
    this.currentPage = this.totalPages;
    this.loadClientsFromAPI();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    this.loadClientsFromAPI();
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      // Show all pages if total pages are less than max
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show current page and surrounding pages
      let startPage = Math.max(1, this.currentPage - 2);
      let endPage = Math.min(this.totalPages, this.currentPage + 2);

      // Adjust if at the beginning or end
      if (this.currentPage <= 3) {
        endPage = maxPagesToShow;
      } else if (this.currentPage >= this.totalPages - 2) {
        startPage = this.totalPages - maxPagesToShow + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

}

interface CompanyNotification {
  id?: string;
  clientId?: string;
  ClientName: string;
  companyRegNo: string;
  Branch: string;
  status: string;
  CMSFinNumber: string;
  Registration: string;
  EmployeeHeadcountLimit: string;
  licenceExpiryDate?: string; // ISO date string from API
}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
  styleUrl: 'dialog-overview-example-dialog.scss',
  imports: [
 MatTableModule ,  ReactiveFormsModule,
 LbnContainerComponent, CheckboxesComponent,LbnInputFieldComponent ,TitleComponent ,LbnAccordianComponent,InputDropdownComponent ,DataPickerComponent,
    MatFormFieldModule,MatSelectModule ,MatDatepickerModule,MatNativeDateModule, FormActionsButtonsComponent,LbnActionButtonComponent,RadioButtonsComponent,
    ReactiveFormsModule,MatCardModule,MatTabsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,MatIconModule,MatDialogModule,CommonModule ,MatButtonModule ,FormsModule,MatInputModule,MatFormFieldModule
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class DialogOverviewExampleDialog implements AfterViewInit {
  readonly dialogRef = inject(MatDialogRef<DialogOverviewExampleDialog>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly animal = model(this.data.animal);

  billingForm: FormGroup;
  branches: Branch[] = [];
  isLoadingBranches = false;
  conditionOptions: Branch[] = [];
  isLoadingConditions = false;
  today = new Date(); // For maxDate on registration date picker
  overrideThemeOptions = [
    { label: 'Yes', checked: false }
  ];
  platformEnabledOptions = [
    { label: 'Enabled', checked: true }
  ];
  // Theme name dropdown options when override is enabled
  themeNameOptions = [
    { name: 'PNP' },
    { name: 'Default' },
   
  ];
    constructor(
      private fb: FormBuilder,
      private cd: ChangeDetectorRef,
      private homeService: HomeService
    ) {
    // initialize form in constructor to avoid using injected service before initialization
    this.billingForm = this.fb.group({

     activeEmployees:  ['', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.min(1), Validators.max(1000000)]],

      clientName: ['', Validators.required],


    registrationDate: ['', Validators.required],
    branch: ['', Validators.required],
    condition: [''],
    companyTheme: [false],
    themeName: ['Labournet'],
    platformEnabled: [true],

    finNumber: ['', [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9]{6}$'),
      Validators.minLength(6),
      Validators.maxLength(6)
    ]],


    });
    // Ensure the conditional 'condition' control is required only when branch === 'Other'
    const branchControl = this.billingForm.get('branch');
    const conditionControl = this.billingForm.get('condition');
    branchControl?.valueChanges.subscribe((val: any) => {
      // Since we now store the code directly as a string
      if (val === 'OTHER') {
        conditionControl?.setValidators([Validators.required]);
      } else {
        conditionControl?.clearValidators();
        conditionControl?.setValue('');
      }
      conditionControl?.updateValueAndValidity();
    });

    this.updateButtonsValues();

    // Use pre-fetched branches and sub-branches from dialog data
    const preFetchedBranches = this.data?.branches;
    const preFetchedSubBranches = this.data?.subBranches;

    if (preFetchedBranches) {
      console.log('✅ Using pre-fetched branches:', preFetchedBranches);
      this.branches = preFetchedBranches;
      this.isLoadingBranches = false;
    } else {
      console.warn('⚠️ No pre-fetched branches, loading from API as fallback');
      this.loadBranches();
    }

    if (preFetchedSubBranches) {
      console.log('✅ Using pre-fetched sub-branches:', preFetchedSubBranches);
      this.conditionOptions = preFetchedSubBranches;
      this.isLoadingConditions = false;
    } else {
      console.warn('⚠️ No pre-fetched sub-branches, loading from API as fallback');
      this.loadSubBranches();
    }

    // Subscribe to form status changes to update button state
    this.billingForm.statusChanges.subscribe(() => {
      this.updateButtonsValues();
      this.cd.markForCheck();
    });
  }

  /**
   * Load branches from API
   */
  private loadBranches(): void {
    this.isLoadingBranches = true;
    this.homeService.getBranches().subscribe({
      next: (response) => {
        this.branches = response.branches;
        this.isLoadingBranches = false;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error loading branches:', error);
        this.isLoadingBranches = false;
        // Fallback to empty array or show error message
        this.branches = [];
        this.cd.markForCheck();
      }
    });
  }

  /**
   * Load sub-branches (conditions) from API
   */
  private loadSubBranches(): void {
    this.isLoadingConditions = true;
    this.homeService.getSubBranches().subscribe({
      next: (response) => {
        this.conditionOptions = response.branches;
        this.isLoadingConditions = false;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error loading sub-branches:', error);
        this.isLoadingConditions = false;
        // Fallback to empty array or show error message
        this.conditionOptions = [];
        this.cd.markForCheck();
      }
    });
  }
    updateButtons:    {
      label: string,
      position: string,
      action: Function,
      disabled?: boolean
    }[] = [];

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCategorySelect(value: any) {
    console.log('Selected branch (raw):', value);
    // The value from input-dropdown is the display name
    // We keep the name in the form control for display
    const branchControl = this.billingForm.get('branch');
    if (branchControl) {
      branchControl.setValue(value);
      console.log('✅ Branch name set to:', value);
    }
  }
  
  // Subscribe to companyTheme changes to toggle themeName validators and value
ngAfterViewInit(): void {
  const themeControl = this.billingForm.get('companyTheme') as FormControl;
  const themeNameControl = this.billingForm.get('themeName') as FormControl;

  themeControl.valueChanges.subscribe((isOverride: boolean) => {
    if (isOverride) {
      // Enable themeName for dropdown selection
      themeNameControl.enable();
      themeNameControl.setValidators([Validators.required]);
      themeNameControl.updateValueAndValidity();
    } else {
      // Read-only mode
      themeNameControl.clearValidators();
      themeNameControl.setValue('Labournet');   // default value
      themeNameControl.disable();               // make read-only
      themeNameControl.updateValueAndValidity();
    }

    this.cd.markForCheck();  // required if OnPush
  });
}


  onThemeSelect(value: any) {
    console.log('Selected theme (raw):', value);
    // Keep the name in the form control for display
    const themeNameControl = this.billingForm.get('themeName');
    if (themeNameControl) {
      themeNameControl.setValue(value);
      console.log('✅ Theme name set to:', value);
    }
  }

  onOverrideThemeChange(selected: string[]) {
    const isYes = selected.includes('Yes');
    this.billingForm.get('companyTheme')?.setValue(isYes);
  }

  onPlatformEnabledChange(selected: string[]) {
    const isEnabled = selected.includes('Enabled');
    this.billingForm.get('platformEnabled')?.setValue(isEnabled);
  }

  onConditionSelect(value: any) {
    console.log('Selected condition (raw):', value);
    // Keep the name in the form control for display
    const conditionControl = this.billingForm.get('condition');
    if (conditionControl) {
      conditionControl.setValue(value);
      console.log('✅ Condition name set to:', value);
    }
  }

  // Helper method to check if the selected branch requires condition field
  isBranchOther(): boolean {
    const branchName = this.billingForm.get('branch')?.value;
    if (!branchName) return false;

    // Find the matching branch and check if its code is 'OTHER'
    const matchingBranch = this.branches.find(b => b.name === branchName);
    return matchingBranch?.code === 'OTHER';
  }

   updateButtonsValues(){
    this.updateButtons = [


    {
      label: 'Save',
      position: 'right',
      action: () => this.onSubmitNewClient(),
      disabled: !this.billingForm.valid
    },
    ]
  }

  //  onSubmit(): void {
  //   if (this.billingForm.invalid) {
  //     this.billingForm.markAllAsTouched();
  //     return;
  //   }
  // }

  get f() {
    return this.billingForm.controls;
  }


onSubmitNewClient() {
  // Validate the form first
  if (this.billingForm.invalid) {
    this.billingForm.markAllAsTouched();
    console.log('Form is invalid', this.billingForm.value);
    return;
  }

  // Build company object from form values
  const form = this.billingForm.value;

  console.log('📋 Raw form values:', form);
  console.log('🌿 Branch value:', form.branch);
  console.log('🏷️ Condition value:', form.condition);

  // Convert branch name to code
  const branchName = form.branch;
  let branchCode = branchName;

  // Look up the code from the name
  const matchingBranch = this.branches.find(b => b.name === branchName);
  if (matchingBranch) {
    branchCode = matchingBranch.code;
  }

  // If branch is 'OTHER', use condition code instead
  let branchValue = branchCode;
  if (branchCode === 'OTHER' && form.condition) {
    const conditionName = form.condition;
    const matchingCondition = this.conditionOptions.find(c => c.name === conditionName);
    branchValue = matchingCondition ? matchingCondition.code : conditionName;
  }

  console.log('✅ Final branch code to submit:', branchValue);

  // Theme name value - use the name directly
  const themeNameValue = form.themeName || 'Labournet';

  // Format data according to API requirements
  const apiPayload: ClientData = {
    clientName: form.clientName,
    cmsFinNumber: form.finNumber,
    registrationDate: this.homeService.formatDateToYYYYMMDD(form.registrationDate),
    employeeHeadCountLimit: parseInt(form.activeEmployees, 10),
    branch: branchValue,
    themeName: themeNameValue,
    platformEnabled: form.platformEnabled ?? true
  };

  console.log('📤 API Payload to submit:', apiPayload);

  

  // Confirm with user then submit via service
  Swal.fire({
    html: `
      <img src="logo.jpg"
           style="width:400px; height:auto; margin-bottom: 5px;" />
      <p>Do you want to add new a client?</p>
    `,
    showCancelButton: true,
    confirmButtonText: 'Submit',
    confirmButtonColor: '#3FB498',
    cancelButtonColor: 'rgba(207, 207, 207, 1)',
  }).then(result => {
    if (result.isConfirmed) {
      // Call the service to submit the data
      this.homeService.submitNewClient(apiPayload).subscribe({
        next: (response) => {
          Swal.fire({
            icon: 'success',
            title: 'Client registration submitted successfully',
            timer: 1500,
            showConfirmButton: false,
            iconColor: '#3FB498',
          });

          // Return display data for local list update
          this.dialogRef.close(apiPayload);
        },
        error: (error) => {
          console.error('Error creating a client:', error);

          // Extract the error message from the API response
          let errorMessage = 'Please try again later';

          if (error.error) {
            // Check for message field (e.g., "Client with CMS Fin Number '123456' already exists in branch 'AGILE_ALLIANCE'")
            if (error.error.message) {
              errorMessage = error.error.message;
            }
            // Check for details array (e.g., ["registrationDate: Registration date cannot be in the future"])
            else if (error.error.details && Array.isArray(error.error.details) && error.error.details.length > 0) {
              errorMessage = error.error.details.join(', ');
            }
            // Fallback to any text in the error object
            else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          }
          // If error.message exists at the top level
          else if (error.message) {
            errorMessage = error.message;
          }

          Swal.fire({
            icon: 'error',
            title: 'Submission failed',
            text: errorMessage,
            confirmButtonColor: '#3FB498',
          });
        }
      });
    }

    if (result.isDismissed) {
      console.log('User cancelled');
    }
  });
}

onClose() {
  this.dialogRef.close();
}

}

@Component({
  selector: 'license-expiry-dialog',
  templateUrl: 'license-expiry-dialog.html',
  styleUrl: 'license-expiry-dialog.scss',
  imports: [
    ReactiveFormsModule,
    LbnContainerComponent,
    CheckboxesComponent,
    LbnInputFieldComponent,
    TitleComponent,
    LbnAccordianComponent,
    InputDropdownComponent,
    DataPickerComponent,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormActionsButtonsComponent,
    LbnActionButtonComponent,
    RadioButtonsComponent,
    MatCardModule,
    MatTabsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
    MatDialogModule,
    CommonModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LicenseExpiryDialog implements OnInit {
  readonly dialogRef = inject(MatDialogRef<LicenseExpiryDialog>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  expiryForm: FormGroup;
  clientData: Client | null = null;
  isLoadingClient = true;
  isLoadingReasons = true;
  today = new Date(); // For minDate on license expiry date picker

  reasonOptions: { name: string; code?: string }[] = [];
  reasonCodeMap: Map<string, string> = new Map(); // Map description to code

  submitButtons: {
    label: string;
    position: string;
    action: Function;
  }[] = [];

  constructor(
    private fb: FormBuilder,
    private homeService: HomeService,
    private cd: ChangeDetectorRef
  ) {
    this.expiryForm = this.fb.group({
      expiryDate: ['', Validators.required],
      reason: ['', Validators.required],
      comment: [''],
    });

    this.updateButtonsValues();
  }

  ngOnInit(): void {
    // Fetch client data
    const clientId = this.data?.clientId;
    if (clientId) {
      console.log('🔍 Fetching client data for ID:', clientId);
      this.homeService.getClientById(clientId).subscribe({
        next: (client) => {
          console.log('✅ Client data loaded:', client);
          this.clientData = client;
          this.isLoadingClient = false;
          this.cd.markForCheck();
        },
        error: (error) => {
          console.error('❌ Failed to load client data:', error);
          this.isLoadingClient = false;
          this.cd.markForCheck();

          // Handle 404 error specifically (client not found)
          if (error.status === 404) {
            Swal.fire({
              icon: 'warning',
              title: 'Client Not Found',
              html: `
                <p>The client you're trying to access could not be found.</p>
                <p>This usually means the client was deleted or the data is out of sync.</p>
                <p><strong>The page will refresh to show current data.</strong></p>
              `,
              confirmButtonText: 'Refresh Now',
              confirmButtonColor: '#3FB498',
            }).then(() => {
              this.dialogRef.close();
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Failed to load client data',
              text: error.error?.message || 'Please try again later',
              confirmButtonColor: '#3FB498',
            }).then(() => {
              this.dialogRef.close();
            });
          }
        }
      });
    } else {
      console.error('❌ No client ID provided to dialog');
      this.isLoadingClient = false;
    }

    // Fetch suspension reasons
    console.log('🔍 Fetching suspension reasons');
    this.homeService.getSuspensionReasons().subscribe({
      next: (response) => {
        console.log('✅ Suspension reasons loaded successfully:', response);
        // Store both display name and code
        this.reasonOptions = response.reasons.map(reason => ({
          name: reason.description,
          code: reason.code
        }));
        // Create mapping from description to code for easy lookup
        response.reasons.forEach(reason => {
          this.reasonCodeMap.set(reason.description, reason.code);
        });
        this.isLoadingReasons = false;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('❌ Failed to load suspension reasons:', error);
        this.isLoadingReasons = false;
        // Fallback to default reasons if API fails
        this.reasonOptions = [
          { name: 'Cancelled', code: 'CANCELLED' },
          { name: 'Non-Payment', code: 'NON_PAYMENT' }
        ];
        this.reasonCodeMap.set('Cancelled', 'CANCELLED');
        this.reasonCodeMap.set('Non-Payment', 'NON_PAYMENT');
        this.cd.markForCheck();
      }
    });
  }

  updateButtonsValues() {
    this.submitButtons = [
      {
        label: 'Submit',
        position: 'right',
        action: () => this.onSubmit(),
      },
    ];
  }

  onReasonSelect(value: any) {
    console.log('Selected reason:', value);
  }

  get f() {
    return this.expiryForm.controls;
  }

  onSubmit() {
    if (this.expiryForm.invalid) {
      this.expiryForm.markAllAsTouched();
      console.log('Form is invalid', this.expiryForm.value);
      return;
    }

    // Get the client ID
    const clientId = this.data?.clientId;
    if (!clientId) {
      console.error('❌ No client ID available for suspension');
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Client ID is missing. Cannot suspend client.',
        confirmButtonColor: '#3FB498',
      });
      return;
    }

    // Get the reason from the form - it might be an object { name: 'Cancelled' } or just a string
    const reasonValue = this.expiryForm.value.reason;
    let reasonDescription: string;

    // Handle both object and string values
    if (typeof reasonValue === 'object' && reasonValue !== null) {
      reasonDescription = reasonValue.name || reasonValue;
    } else {
      reasonDescription = reasonValue;
    }

    // Map the description to the code (e.g., "Cancelled" -> "CANCELLED")
    const reasonCode = this.reasonCodeMap.get(reasonDescription) || reasonDescription;

    console.log('🔍 Form value:', this.expiryForm.value);
    console.log('🔍 Reason value from form:', reasonValue);
    console.log('🔍 Reason description:', reasonDescription);
    console.log('🔍 Reason code (mapped):', reasonCode);
    console.log('🔍 Available reason codes:', Array.from(this.reasonCodeMap.entries()));

    // Prepare the suspend request data
    const suspendData: SuspendClientRequest = {
      licenceExpiryDate: this.homeService.formatDateToYYYYMMDD(this.expiryForm.value.expiryDate),
      reason: reasonCode,
      comments: this.expiryForm.value.comment || undefined 
      
    };

    console.log('📋 Suspend request data:', suspendData);

    Swal.fire({
      html: `
        <img src="logo.jpg"
             style="width:400px; height:auto; margin-bottom: 5px;" />
        <p>Do you want to suspend this client?</p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Suspend',
      confirmButtonColor: '#3FB498',
      cancelButtonColor: 'rgba(207, 207, 207, 1)',
    }).then(result => {
      if (result.isConfirmed) {
        // Call the suspend API
        this.homeService.suspendClient(clientId, suspendData).subscribe({
          next: (response) => {
            console.log('✅ Client suspended:', response);
            Swal.fire({
              icon: 'success',
              title: 'Client suspended successfully',
              timer: 1500,
              showConfirmButton: false,
              iconColor: '#3FB498',
            });

            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('❌ Error suspending client:', error);

            // Handle 404 error specifically (client not found)
            if (error.status === 404) {
              Swal.fire({
                icon: 'warning',
                title: 'Client Not Found',
                html: `
                  <p>The client you're trying to suspend could not be found.</p>
                  <p>This usually means the client was deleted or the data is out of sync.</p>
                  <p><strong>The page will refresh to show current data.</strong></p>
                `,
                confirmButtonText: 'Refresh Now',
                confirmButtonColor: '#3FB498',
              }).then(() => {
                // Close dialog and refresh the client list
                this.dialogRef.close();
                // Trigger refresh in parent component by returning a special value
                // The parent component should handle this
                window.location.reload();
              });
            } else {
              // Extract the error message from the API response
              let errorMessage = 'Please try again later';

              if (error.error) {
                if (error.error.message) {
                  errorMessage = error.error.message;
                } else if (error.error.details && Array.isArray(error.error.details) && error.error.details.length > 0) {
                  errorMessage = error.error.details.join(', ');
                } else if (typeof error.error === 'string') {
                  errorMessage = error.error;
                }
              } else if (error.message) {
                errorMessage = error.message;
              }

              Swal.fire({
                icon: 'error',
                title: 'Suspension failed',
                text: errorMessage,
                confirmButtonColor: '#3FB498',
              });
            }
          }
        });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'reactivate-client-dialog',
  templateUrl: './reactivate-client-dialog.html',
  styleUrl: './reactivate-client-dialog.scss',
  imports: [
    ReactiveFormsModule,
    LbnContainerComponent,
    CheckboxesComponent,
    LbnInputFieldComponent,
    TitleComponent,
    LbnAccordianComponent,
    InputDropdownComponent,
    DataPickerComponent,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormActionsButtonsComponent,
    LbnActionButtonComponent,
    RadioButtonsComponent,
    MatCardModule,
    MatTabsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
    MatDialogModule,
    CommonModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReactivateClientDialog implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ReactivateClientDialog>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  reactivateForm: FormGroup;
  clientData: Client | null = null;
  isLoadingClient = true;
  minReactivationDate: Date = new Date(); // Default to today, will be updated to license expiry date

  submitButtons: {
    label: string;
    position: string;
    action: Function;
  }[] = [];

  constructor(
    private fb: FormBuilder,
    private homeService: HomeService,
    private cd: ChangeDetectorRef
  ) {
    this.reactivateForm = this.fb.group({
      reactivationDate: ['', Validators.required],
      comment: [''],
    });

    this.updateButtonsValues();
  }

  ngOnInit(): void {
    // Use pre-fetched client data from dialog data
    const clientData = this.data?.clientData;
    if (clientData) {
      console.log('✅ Using pre-fetched client data:', clientData);
      this.clientData = clientData;
      this.isLoadingClient = false;

      // Set minReactivationDate to the license expiry date (or today if not available)
      if (clientData.licenceExpiryDate) {
        try {
          // Parse the license expiry date (format: YYYY-MM-DD)
          const expiryDate = new Date(clientData.licenceExpiryDate);
          if (!isNaN(expiryDate.getTime())) {
            this.minReactivationDate = expiryDate;
            console.log('✅ Minimum reactivation date set to license expiry date:', this.minReactivationDate);
          } else {
            console.warn('⚠️ Invalid license expiry date, using today as minimum');
          }
        } catch (error) {
          console.error('❌ Error parsing license expiry date:', error);
        }
      } else {
        console.warn('⚠️ No license expiry date found in client data, using today as minimum');
      }

      this.cd.markForCheck();
    } else {
      console.error('❌ No client data provided to dialog');
      this.isLoadingClient = false;
      Swal.fire({
        icon: 'error',
        title: 'Failed to load client data',
        text: 'Client data is missing. Please try again.',
        confirmButtonColor: '#3FB498',
      }).then(() => {
        this.dialogRef.close();
      });
    }
  }

  updateButtonsValues() {
    this.submitButtons = [
      {
        label: 'Reactivate',
        position: 'right',
        action: () => this.onSubmit(),
      },
    ];
  }

  get f() {
    return this.reactivateForm.controls;
  }

  onSubmit() {
    if (this.reactivateForm.invalid) {
      this.reactivateForm.markAllAsTouched();
      console.log('Form is invalid', this.reactivateForm.value);
      return;
    }

    // Get the client ID
    const clientId = this.data?.clientId;
    if (!clientId) {
      console.error('❌ No client ID available for reactivation');
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Client ID is missing. Cannot reactivate client.',
        confirmButtonColor: '#3FB498',
      });
      return;
    }

    // Prepare the reactivate request data
    const reactivateData: ReactivateClientRequest = {
      licenceReactivationDate: this.homeService.formatDateToYYYYMMDD(this.reactivateForm.value.reactivationDate),
      comments: this.reactivateForm.value.comment || undefined
    };

    console.log('📋 Reactivate request data:', reactivateData);

    Swal.fire({
      html: `
        <img src="logo.jpg"
             style="width:400px; height:auto; margin-bottom: 5px;" />
        <p>Do you want to reactivate this client?</p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Reactivate',
      confirmButtonColor: '#3FB498',
      cancelButtonColor: 'rgba(207, 207, 207, 1)',
    }).then(result => {
      if (result.isConfirmed) {
        // Call the reactivate API
        this.homeService.reactivateClient(clientId, reactivateData).subscribe({
          next: (response) => {
            console.log('✅ Client reactivated:', response);
            Swal.fire({
              icon: 'success',
              title: 'Client reactivated successfully',
              timer: 1500,
              showConfirmButton: false,
              iconColor: '#3FB498',
            });

            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('❌ Error reactivating client:', error);

            // Extract the error message from the API response
            let errorMessage = 'Please try again later';

            if (error.error) {
              if (error.error.message) {
                errorMessage = error.error.message;
              } else if (error.error.details && Array.isArray(error.error.details) && error.error.details.length > 0) {
                errorMessage = error.error.details.join(', ');
              } else if (typeof error.error === 'string') {
                errorMessage = error.error;
              }
            } else if (error.message) {
              errorMessage = error.message;
            }

            Swal.fire({
              icon: 'error',
              title: 'Reactivation failed',
              text: errorMessage,
              confirmButtonColor: '#3FB498',
            });
          }
        });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'update-client-dialog',
  templateUrl: './update-client-dialog.html',
  styleUrl: './update-client-dialog.scss',
  imports: [
    ReactiveFormsModule,
    LbnContainerComponent,
    CheckboxesComponent,
    LbnInputFieldComponent,
    TitleComponent,
    LbnAccordianComponent,
    InputDropdownComponent,
    DataPickerComponent,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormActionsButtonsComponent,
    LbnActionButtonComponent,
    RadioButtonsComponent,
    MatCardModule,
    MatTabsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
    MatDialogModule,
    CommonModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateClientDialog implements OnInit, AfterViewInit {
  readonly dialogRef = inject(MatDialogRef<UpdateClientDialog>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  updateForm: FormGroup;
  clientData: Client | null = null;
  isLoadingClient = true;
  branches: Branch[] = [];
  isLoadingBranches = false;
  conditionOptions: Branch[] = [];
  isLoadingConditions = false;
  today = new Date(); // For maxDate on registration date picker
  overrideThemeOptions = [
    { label: 'Yes', checked: false }
  ];
  platformEnabledOptions = [
    { label: 'Enabled', checked: true }
  ];
  themeNameOptions = [
    { name: 'PNP' },
    { name: 'Default' },
  ];

  submitButtons: {
    label: string;
    position: string;
    action: Function;
  }[] = [];

  constructor(
    private fb: FormBuilder,
    private homeService: HomeService,
    private cd: ChangeDetectorRef
  ) {
    this.updateForm = this.fb.group({
      companyCode: [{ value: '', disabled: true }],
      activeEmployees: ['', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.min(1), Validators.max(1000000)]],
      clientName: ['', Validators.required],
      registrationDate: ['', Validators.required],
      branch: [{ value: '', disabled: true }],
      condition: [{ value: '', disabled: true }],
      companyTheme: [false],
      themeName: ['Labournet'],
      platformEnabled: [true],
      finNumber: ['', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]{6}$'),
        Validators.minLength(6),
        Validators.maxLength(6)
      ]],
    });

    const branchControl = this.updateForm.get('branch');
    const conditionControl = this.updateForm.get('condition');
    branchControl?.valueChanges.subscribe((val: any) => {
      if (val === 'OTHER') {
        conditionControl?.setValidators([Validators.required]);
      } else {
        conditionControl?.clearValidators();
        conditionControl?.setValue('');
      }
      conditionControl?.updateValueAndValidity();
    });

    this.updateButtonsValues();
  }

  ngOnInit(): void {
    this.loadBranches();
    this.loadSubBranches();

    // Use pre-fetched client data from dialog data
    const clientData = this.data?.clientData;
    if (clientData) {
      console.log('✅ Using pre-fetched client data:', clientData);
      this.clientData = clientData;
      this.isLoadingClient = false;

      // Populate form immediately with pre-fetched data
      setTimeout(() => {
        this.populateForm(clientData);
        this.cd.markForCheck();
      }, 300);
    } else {
      console.error('❌ No client data provided to dialog');
      this.isLoadingClient = false;
      Swal.fire({
        icon: 'error',
        title: 'Failed to load client data',
        text: 'Client data is missing. Please try again.',
        confirmButtonColor: '#3FB498',
      }).then(() => {
        this.dialogRef.close();
      });
    }
  }

  ngAfterViewInit(): void {
    const themeControl = this.updateForm.get('companyTheme') as FormControl;
    const themeNameControl = this.updateForm.get('themeName') as FormControl;

    themeControl.valueChanges.subscribe((isOverride: boolean) => {
      if (isOverride) {
        themeNameControl.enable();
        themeNameControl.setValidators([Validators.required]);
        themeNameControl.updateValueAndValidity();
      } else {
        themeNameControl.clearValidators();
        themeNameControl.setValue('Labournet');
        themeNameControl.disable();
        themeNameControl.updateValueAndValidity();
      }

      this.cd.markForCheck();
    });
  }

  private populateForm(client: Client): void {
    const isThemeOverride = !!(client.themeName && client.themeName !== 'Labournet');

    this.overrideThemeOptions = [
      { label: 'Yes', checked: isThemeOverride }
    ];
    this.platformEnabledOptions = [
      { label: 'Enabled', checked: client.platformEnabled ?? true }
    ];

    const isSubBranch = this.conditionOptions.some(opt => opt.code === client.branch);

    // Convert branch code to name for display
    let branchDisplayValue = client.branch;
    let conditionDisplayValue = '';

    if (isSubBranch) {
      // Branch is a sub-branch, so display "OTHER" branch name and set condition name
      const matchingSubBranch = this.conditionOptions.find(b => b.code === client.branch);
      const otherBranch = this.branches.find(b => b.code === 'OTHER');
      branchDisplayValue = otherBranch ? otherBranch.name : 'OTHER';
      conditionDisplayValue = matchingSubBranch ? matchingSubBranch.name : client.branch;
    } else {
      // Branch is a main branch, convert code to name
      const matchingBranch = this.branches.find(b => b.code === client.branch);
      branchDisplayValue = matchingBranch ? matchingBranch.name : client.branch;
    }

    this.updateForm.patchValue({
      companyCode: client.companyRegNo,
      activeEmployees: client.employeeHeadCountLimit.toString(),
      clientName: client.clientName,
      registrationDate: new Date(client.registrationDate),
      branch: branchDisplayValue,
      condition: conditionDisplayValue,
      companyTheme: isThemeOverride,
      themeName: client.themeName || 'Labournet',
      platformEnabled: client.platformEnabled ?? true,
      finNumber: client.cmsFinNumber,
    });

    console.log('📋 Form populated with client data:', this.updateForm.value);
  }

  private loadBranches(): void {
    this.isLoadingBranches = true;
    this.homeService.getBranches().subscribe({
      next: (response) => {
        this.branches = response.branches;
        this.isLoadingBranches = false;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error loading branches:', error);
        this.isLoadingBranches = false;
        this.branches = [];
        this.cd.markForCheck();
      }
    });
  }

  private loadSubBranches(): void {
    this.isLoadingConditions = true;
    this.homeService.getSubBranches().subscribe({
      next: (response) => {
        this.conditionOptions = response.branches;
        this.isLoadingConditions = false;
        this.cd.markForCheck();
      },
      error: (error) => {
        console.error('Error loading sub-branches:', error);
        this.isLoadingConditions = false;
        this.conditionOptions = [];
        this.cd.markForCheck();
      }
    });
  }

  updateButtonsValues() {
    this.submitButtons = [
      {
        label: 'Update',
        position: 'right',
        action: () => this.onSubmit(),
      },
    ];
  }

  get f() {
    return this.updateForm.controls;
  }

  onCategorySelect(value: any) {
    console.log('Selected branch (raw):', value);
    // Store the name for display
    const branchControl = this.updateForm.get('branch');
    if (branchControl) {
      branchControl.setValue(value);
      console.log('✅ Branch name set to:', value);
    }
  }

  onThemeSelect(value: any) {
    console.log('Selected theme (raw):', value);
    // Store the name for display
    const themeNameControl = this.updateForm.get('themeName');
    if (themeNameControl) {
      themeNameControl.setValue(value);
      console.log('✅ Theme name set to:', value);
    }
  }

  onOverrideThemeChange(selected: string[]) {
    const isYes = selected.includes('Yes');
    this.updateForm.get('companyTheme')?.setValue(isYes);
  }

  onPlatformEnabledChange(selected: string[]) {
    const isEnabled = selected.includes('Enabled');
    this.updateForm.get('platformEnabled')?.setValue(isEnabled);
  }

  onConditionSelect(value: any) {
    console.log('Selected condition (raw):', value);
    // Store the name for display
    const conditionControl = this.updateForm.get('condition');
    if (conditionControl) {
      conditionControl.setValue(value);
      console.log('✅ Condition name set to:', value);
    }
  }

  // Helper method to check if the selected branch requires condition field
  isUpdateBranchOther(): boolean {
    const branchName = this.updateForm.get('branch')?.value;
    if (!branchName) return false;

    // Find the matching branch and check if its code is 'OTHER'
    const matchingBranch = this.branches.find(b => b.name === branchName);
    return matchingBranch?.code === 'OTHER';
  }

  onSubmit() {
    if (this.updateForm.invalid) {
      this.updateForm.markAllAsTouched();
      console.log('Form is invalid', this.updateForm.value);
      return;
    }

    const clientId = this.data?.clientId;
    if (!clientId) {
      console.error('❌ No client ID available for update');
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Client ID is missing. Cannot update client.',
        confirmButtonColor: '#3FB498',
      });
      return;
    }

    // Use getRawValue() to include disabled controls
    const form = this.updateForm.getRawValue();

    // Convert branch name to code for API submission
    const branchName = form.branch;
    const matchingBranch = this.branches.find(b => b.name === branchName);
    const branchCode = matchingBranch ? matchingBranch.code : branchName;

    // Determine final branch value (use condition code if branch is OTHER)
    let branchValue = branchCode;
    if (branchCode === 'OTHER' && form.condition) {
      const matchingCondition = this.conditionOptions.find(c => c.name === form.condition);
      branchValue = matchingCondition ? matchingCondition.code : form.condition;
    }

    const themeNameValue = form.themeName || 'Labournet';

    const updateData: UpdateClientRequest = {
      clientName: form.clientName,
      cmsFinNumber: form.finNumber,
      registrationDate: this.homeService.formatDateToYYYYMMDD(form.registrationDate),
      employeeHeadCountLimit: parseInt(form.activeEmployees, 10),
      branch: branchValue,
      themeName: themeNameValue,
      platformEnabled: form.platformEnabled ?? true
    };

    console.log('📋 Update request data:', updateData);

    Swal.fire({
      html: `
        <img src="logo.jpg"
             style="width:400px; height:auto; margin-bottom: 5px;" />
        <p>Do you want to update this client?</p>
      `,
      showCancelButton: true,
      confirmButtonText: 'Update',
      confirmButtonColor: '#3FB498',
      cancelButtonColor: 'rgba(207, 207, 207, 1)',
    }).then(result => {
      if (result.isConfirmed) {
        this.homeService.updateClient(clientId, updateData).subscribe({
          next: (response) => {
            console.log('✅ Client updated:', response);
            Swal.fire({
              icon: 'success',
              title: 'Client updated successfully',
              timer: 1500,
              showConfirmButton: false,
              iconColor: '#3FB498',
            });

            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('❌ Error updating client:', error);

            // Extract the error message from the API response
            let errorMessage = 'Please try again later';

            if (error.error) {
              // Check for message field (e.g., "Client with CMS Fin Number '123456' already exists in branch 'AGILE_ALLIANCE'")
              if (error.error.message) {
                errorMessage = error.error.message;
              }
              // Check for details array (e.g., ["registrationDate: Registration date cannot be in the future"])
              else if (error.error.details && Array.isArray(error.error.details) && error.error.details.length > 0) {
                errorMessage = error.error.details.join(', ');
              }
              // Fallback to any text in the error object
              else if (typeof error.error === 'string') {
                errorMessage = error.error;
              }
            }
            // If error.message exists at the top level
            else if (error.message) {
              errorMessage = error.message;
            }

            Swal.fire({
              icon: 'error',
              title: 'Update failed',
              text: errorMessage,
              confirmButtonColor: '#3FB498',
            });
          }
        });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
